import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PaymentsTableTab from '@/components/payments/PaymentsTableTab.vue';
import type { PaymentsTabId } from '@/composables/usePayments';
import { ALL_STATUSES } from '@/services/paymentStatus';


export default /*@__PURE__*/_defineComponent({
  __name: 'AllPaymentsTab',
  props: {
    tabId: {}
  },
  setup(__props: any) {

/* eslint-env vue/setup-compiler-macros */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PaymentsTableTab, {
    "status-options": _unref(ALL_STATUSES),
    "empty-description": "No payments match your current filters.",
    "action-mode": "none"
  }, null, 8, ["status-options"]))
}
}

})